const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const GetOverViewInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'OVERVIEW_INVOICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'OVERVIEW_INVOICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default GetOverViewInvoice;